import { C, S } from "../customers/theme";
import { GRN_STATUSES } from "../lib/goodsReceived";

const statusOf = (v) => GRN_STATUSES.find((s) => s.value === v) || { label: v, color: C.textDim };
export function GRNStatusBadge({ status }) {
  const s = statusOf(status);
  return <span style={S.pill(s.color)}>{s.label}</span>;
}

export default function GRNView({ grn, onClose, onEdit }) {
  const lines = (grn.goods_received_note_lines || []).slice().sort((a, b) => (a.position || 0) - (b.position || 0));
  const sup = grn.suppliers || {};
  const po = grn.purchase_orders || {};
  const n = (x) => Number(x) || 0;
  const sum = lines.reduce((a, l) => ({ received: a.received + n(l.quantity_received), rejected: a.rejected + n(l.quantity_rejected), remaining: a.remaining + n(l.quantity_remaining) }), { received: 0, rejected: 0, remaining: 0 });

  return (
    <div style={S.modal} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{ ...S.modalBox, width: 880 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>{grn.grn_number}</h2>
            <div style={{ color: C.textMuted, fontSize: 13, marginTop: 3 }}>against {po.po_number || "—"} · {sup.company_name || "—"}</div>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <GRNStatusBadge status={grn.status} />
            <button onClick={() => onEdit(grn)} style={S.btn()}>Edit</button>
            <button onClick={onClose} aria-label="Close" style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: C.textMuted }}>✕</button>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, marginTop: 14 }}>
          <div>
            <div style={S.sectionTitle}>Supplier</div>
            <div style={{ fontSize: 13, lineHeight: 1.7 }}>
              <div><strong>{sup.company_name || "—"}</strong></div>
              {sup.contact_name && <div style={{ color: C.textMuted }}>👤 {sup.contact_name}</div>}
              {sup.email && <div style={{ color: C.textMuted }}>✉️ {sup.email}</div>}
            </div>
          </div>
          <div>
            <div style={S.sectionTitle}>Delivery</div>
            <div style={{ fontSize: 13, lineHeight: 1.7, color: C.textMuted }}>
              <div>Date: <span style={{ color: C.text }}>{grn.delivery_date || "—"}</span></div>
              <div>Reference: <span style={{ color: C.text }}>{grn.delivery_reference || "—"}</span></div>
              <div>Received by: <span style={{ color: C.text }}>{grn.received_by || "—"}</span></div>
            </div>
          </div>
        </div>

        <div style={S.sectionTitle}>Items received</div>
        <table style={S.table}>
          <thead><tr>
            {["Product", "SKU", "Ordered", "Prev", "Received", "Remaining", "Rejected", "Batch", "Expiry"].map((h) => <th key={h} style={S.th}>{h}</th>)}
          </tr></thead>
          <tbody>
            {lines.length === 0 ? <tr><td colSpan={9} style={S.empty}>No lines</td></tr> : lines.map((l) => (
              <tr key={l.id}>
                <td style={S.td}>{l.description || "—"}</td>
                <td style={S.td}>{l.sku || "—"}</td>
                <td style={S.td}>{l.ordered_quantity}</td>
                <td style={S.td}>{l.previously_received}</td>
                <td style={S.td}><strong style={{ color: C.success }}>{l.quantity_received}</strong></td>
                <td style={S.td}><span style={{ color: n(l.quantity_remaining) > 0 ? C.warning : C.textMuted }}>{l.quantity_remaining}</span></td>
                <td style={S.td}>{n(l.quantity_rejected) > 0 ? <span style={{ color: C.danger }}>{l.quantity_rejected}</span> : "—"}</td>
                <td style={S.td}>{l.batch_number || "—"}</td>
                <td style={S.td}>{l.expiry_date || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ display: "flex", gap: 18, flexWrap: "wrap", background: C.surface2, borderRadius: 8, padding: "10px 16px", marginTop: 12, fontSize: 13 }}>
          <span style={{ color: C.textMuted }}>Received <strong style={{ color: C.success }}>{sum.received}</strong></span>
          <span style={{ color: C.textMuted }}>Rejected <strong style={{ color: sum.rejected > 0 ? C.danger : C.text }}>{sum.rejected}</strong></span>
          <span style={{ color: C.textMuted }}>Outstanding <strong style={{ color: sum.remaining > 0 ? C.warning : C.success }}>{sum.remaining}</strong></span>
        </div>

        {grn.notes && (<><div style={S.sectionTitle}>Notes</div><div style={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{grn.notes}</div></>)}
      </div>
    </div>
  );
}
